import React from "react";
import { Button, Icon } from "react-materialize";

export default function BtnAddByUser() {
  return (
    <a
      href="/employees/"
      target="_blank"
      rel="noreferrer"
    >
      <Button
        flat
        node="button"
        waves="light"
        className="btn-top-right textcolor-green"
        id="btn-add-by-user"
      >
        Add New By User
        <Icon right>person</Icon>
      </Button>
    </a>
  );
}
